export default __webpack_public_path__ + "static/media/weight_female@3x.e225050a.png";